module.exports = "/_next/static/resources/life1-bc4ef23bf5a567146260256ae81d7a4a.webp";